import { DragDropModule } from '@angular/cdk/drag-drop';
import { Component, ChangeDetectorRef, ChangeDetectionStrategy, Inject, ViewChild, Input } from '@angular/core';
import { CdkPortalOutlet, PortalModule, ComponentPortal } from '@angular/cdk/portal';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RMS_PULLDOWN_DATA } from './rms-pulldown.tokens';
import { RmsPulldownRef } from './rms-pulldown-ref';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'rms-pulldown-container',
  standalone: true,
  imports: [DragDropModule, PortalModule, MatIconModule, MatButtonModule],
  templateUrl:'./rms-pulldown.component.html',
  styleUrls: ['./rms-pulldown.component.scss'],
  animations: [
    trigger('pulldown', [
      state('open', style({ transform: 'translateY(0)', opacity: 1 })),
      state('closing', style({ transform: 'translateY(-16px)', opacity: 0 })),
      transition('void => open', [
        style({ transform: 'translateY(-24px)', opacity: 0 }),
        animate('500ms ease-out')
      ]),
      transition('open => closing', [
        animate('500ms ease-in')
      ])
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RmsPulldownContainerComponent {
  @ViewChild(CdkPortalOutlet, { static: true }) outlet!: CdkPortalOutlet;

  @Input() movable = false;

  animState: 'open' | 'closing' = 'open';
  private pendingCloseResult: any;

  constructor(
    public readonly ref: RmsPulldownRef,
    private readonly cdr: ChangeDetectorRef,
    @Inject(RMS_PULLDOWN_DATA) public readonly data: any
  ) { this.movable = data?.movable ?? false; }

  attach<T>(portal: ComponentPortal<any>): any {
    return this.outlet.attachComponentPortal(portal);
  }

  requestClose(result?: any) {
    if (!this.ref.canClose()) return;
    this.pendingCloseResult = result;
    this.animState = 'closing';
    this.cdr.markForCheck();
  }

  onAnimDone(e: any) {
    if (this.animState === 'closing') {
      this.ref._finishClose(this.pendingCloseResult);
    }
  }
}
